import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './font.css';
import './index.css';

createRoot(document.getElementById('root')!).render(
	<BrowserRouter>
		<App />
	</BrowserRouter>
);

//Disabled strict mode because of a bug with the editors
//https://github.com/zenoamaro/react-quill/pull/793
//re-enable strictmode as soon as the new release is done
